import { useSearchParams } from 'react-router-dom';
import { isMockEnabled } from '@/mocks';
import { isDemoScenario, type DemoScenario } from './scenario';

/** `?cenario=` da URL, só quando o front roda em cima dos mocks. Fora disso é sempre `normal`. */
export function useDemoScenario(): DemoScenario {
  const [params] = useSearchParams();
  if (!isMockEnabled()) return 'normal';
  const raw = params.get('cenario');
  return isDemoScenario(raw) ? raw : 'normal';
}
